/*
import "./config/chartSetup"; // ✅ Registro global de tipos de gráficos Chart.js

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { LanguageProvider } from './context/LanguageContext';



const container = document.getElementById('root')
const root = ReactDOM.createRoot(container)
const app = (
  <React.StrictMode>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </React.StrictMode>

)
root.render(app)

*/

//v2
// ✅ Importación necesaria para forzar ejecución de chartSetup.js


import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { LanguageProvider } from "./context/LanguageContext";

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </React.StrictMode>
);
